import { STORAGE_PREFIX, StorageItem } from "~/types"

export const SessionStorage = {
  setItems(items: Array<StorageItem>, storagePrefix = STORAGE_PREFIX) {
    items.forEach((item) => {
      if (storagePrefix) {
        sessionStorage.setItem(`${storagePrefix}${item.key}`, item.value)
      } else {
        sessionStorage.setItem(item.key, item.value)
      }
    })
  },
  getItems(keys: string[], storagePrefix = STORAGE_PREFIX) {
    if (storagePrefix) {
      return keys.map((key) => sessionStorage.getItem(`${storagePrefix}${key}`))
    }

    return keys.map((key) => sessionStorage.getItem(key))
  },
  getItem(key: string, storagePrefix = STORAGE_PREFIX) {
    if (storagePrefix) {
      return sessionStorage.getItem(`${storagePrefix}${key}`)
    }

    return sessionStorage.getItem(key)
  },
  getAllKeys(storagePrefix = STORAGE_PREFIX): string[] {
    return Array.from(Array(sessionStorage.length))
      .map((_, index) => sessionStorage.key(index))
      .filter((key) => {
        if (storagePrefix && key) {
          return key.startsWith(storagePrefix)
        }

        return !!key
      }) as string[]
  },
  setItem(item: StorageItem, storagePrefix = STORAGE_PREFIX) {
    if (storagePrefix) {
      return sessionStorage.setItem(`${storagePrefix}${item.key}`, item.value)
    }

    return sessionStorage.setItem(item.key, item.value)
  },
  removeItem(key: string, storagePrefix = STORAGE_PREFIX) {
    if (storagePrefix) {
      return sessionStorage.removeItem(`${storagePrefix}${key}`)
    }

    return sessionStorage.removeItem(key)
  },
  removeItems(keys: string[], storagePrefix = STORAGE_PREFIX) {
    keys.forEach((key) => {
      if (storagePrefix) {
        sessionStorage.removeItem(`${storagePrefix}${key}`)
      } else {
        sessionStorage.removeItem(key)
      }
    })
  },
}

export const SESSION_STORAGE_KEYS = {
  CODE_VERIFIER: "code_verifier",
  AFTER_AUTH_REDIRECT_URL: "after_auth_redirect_url",
}
